import React from "react"
import styled from "styled-components"
import Container from "./forLayout/container"
import Button from "./button/button"

const Divider = styled.div`
  width: 7%;
  border: 2px solid white;
`

const SectionTitle = styled.h2`
  font-family: "GFS Didot", serif;
  font-size: 4rem;
  line-height: 4rem;
  margin-bottom: 2rem;
`

const Spacer = styled.div`
  padding: 1.5rem 0;
`

const SectionParagraph = styled.p`
  font-family: "GFS Didot", serif;
  font-size: 1.4rem;
  line-height: 2.5rem;
  margin: 0;
  color: #dedede;
  max-width: 650px;
  a {
    text-decoration: underline;
    color: #fff;
  }
  a:hover {
    color: #fff;
  }
`

const FifthSection = () => {
  return (
    <Container>
      <Divider />
      <Spacer />
      <SectionTitle>Inspire girls to reach their crazy dreams</SectionTitle>
      <SectionParagraph>
        Whether you want to be a mentor or a coach, your participation can make
        a difference on the next generation of female athletes. Learn more about
        Nike’s commitment to getting girls moving and find out how you can make
        an impact.
      </SectionParagraph>
      <Spacer />
      <a href="https://www.nike.com/id/en_gb/c/made-to-play">
        <Button>Get Involved</Button>
      </a>
    </Container>
  )
}

export default FifthSection
